// @ts-nocheck
import styled from 'styled-components';

export const FiltersSettingsStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .filtersSettings {
    &__datesSection {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 0.75rem;
      align-items: flex-end;
    }

    &__section {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
      font-family: ${props => props.theme.fontSemiBold};
      font-size: ${props => props.theme.fontSizeS};
      color: #89A0C9;

      &Content {
        align-items: flex-start;
        background-color: ${props => props.theme.white};
        border-radius: 0.25rem;
        display: flex;
        flex-direction: column;
        padding: 16px;
        row-gap: 16px;

        &ImportButton {
          padding: 0;
        }

        .reportFilters {
          flex-wrap: wrap;
          gap: 16px;
          margin-bottom: 0;
        }
      }
    }
  }
`;
